// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SyQNhGiXQPXGMA {\n  margin: 0 4px 0 0;\n}\n._0dxRW9UJcBGlXp {\n  padding-left: 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showSidebarButton": "SyQNhGiXQPXGMA",
	"showSidebarButtonWithText": "_0dxRW9UJcBGlXp"
};
export default ___CSS_LOADER_EXPORT___;
